/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {ResourceHelper} from '../../components/util/resource-helper';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class LocationApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  search(params: Record<string, any>): Observable<any> {
    const normalized = {...params};
    if (Array.isArray(normalized.types)) {
      normalized.types = normalized.types.join(';');
    }
    if (!normalized.q && normalized.types && !normalized.blankOrderBy) {
      normalized.orderBy = 'NAME';
    }
    normalized.q = ResourceHelper.uiSrefUpdater(normalized.q);
    normalized.labels = ResourceHelper.uiSrefUpdater(normalized.labels);
    if (normalized.q && normalized.q.length < 3 && !normalized.q.endsWith('*')) {
      normalized.q += '*';
    }
    if (!normalized.objectState) {
      normalized.objectState = 'ACTIVE';
    }
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('location'),
      params: normalized
    });
  }

  getMunicipalities(country: string): Observable<any[]> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('location/municipalities'),
      params: {country}
    });
  }
}
